import Joi from "joi";
import { useDictionary } from "../../contexts/dictionary";
import { BoxContainer, Col, HeroBanner, List, ListItem, Row, TabButtons, TabButtonsItem, Text, Title, VerticalSeparator, VImage } from "../../style/base.style";
import { Colors } from "../../style/colors";



import { Link, useNavigate } from "react-router-dom";
import { useDeviceType } from "../../contexts/DeviceContext";
import { FieldType, TextFieldType } from "../fields";
import { VerticalSepWithTitle } from "../common/verticalSepWithTitle";
import { FormComponent } from "../form";
import { ActionButton } from "../buttons/ActionButton";
import { useFormHandling } from "../../hooks/formUtils";
import { EmailPasswordAuthNew, OtpAuth, PhoneAuthNew } from "../../hooks/socialAuth";
import { useEffect, useState } from "react";
import { RequestConfigs } from "../../api";
import { SocialAuthComponent } from "../socialAuth";
import { TextLink } from "../common/TextLink";
import { useContactType } from "../../contexts/ContactContext";
import { routesMap } from "../../constants/routes";


export const ForgotPasswordComponent = () => {


  const { translate } = useDictionary()
  const { isMobile } = useDeviceType()
  const navigate = useNavigate();
  const [formData,setFormData] = useState<any>()



  


  const fields: FieldConfig[] = [

    {
      type: FieldType.text,
      name: "Email",
      label: translate("email_label"),
      joiSchema: Joi.string().email({ tlds: { allow: false } }).required(),
      typeOptions: {
        type: TextFieldType.text,
      }
    },

   
  ]




  const [combineServerRes, setCombineServerRes] = useState<ApiResponse | null>(null);


  const handleInputChange = (name: string, value: string) => {
    setFormData((prev:any) => ({ ...prev, [name]: value }))
  }

  const { resetPassword } = EmailPasswordAuthNew()
  



  const processResetPassword = async () => {
    const resetRes = await resetPassword(formData.Email)
    console.log("resetRes res", resetRes)  
    setCombineServerRes(resetRes as ApiResponse)

  }

  useEffect(() => {
    if (combineServerRes?.succeeded) {
      navigate(routesMap.forgotPasswordThankYou.to)
    }
  }, [combineServerRes])



  const goBack = () => {
    navigate(-1);
  };




    return (


      <Col $justifyContent="flex-start" style={{ maxWidth: '500px' }} $width={isMobile ? "100%" : "60%"} $border={`1px solid${Colors.fieldBorder}`} $borderRadius={10} $backgroundColor={Colors.whiteBackground} $gap={10} $padding="20px">
        <FormComponent
          fields={fields}
          title={translate("reset_password")}
          onChange={handleInputChange}
          serverRes={combineServerRes}
        />
        <ActionButton width="100%" onClick={() => { processResetPassword() }} label={translate('reset_password')} />

        <VerticalSepWithTitle />
       
        <div className="contact-signup">
          <p>
           
            <TextLink onClick={goBack}>{translate('go_back')}</TextLink>

          </p>
        </div>

      </Col>

    )



};